var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendarPlus = function SvgIconCalendarPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11.625a1 1 0 1 0-2 0v1.625H9.375a1 1 0 1 0 0 2H11v1.625a1 1 0 1 0 2 0V15.25h1.625a1 1 0 1 0 0-2H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 1.875a1 1 0 1 0-2 0v.875h-7v-.875a1 1 0 0 0-2 0v.875h-2A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75h-2zm1.75 5.375v-2.5H4.75v2.5zm-14.5 2h14.5v10H4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCalendarPlus;